import PropTypes from 'prop-types'

import { useStyletron } from 'baseui'
import Icon from 'baseui/icon/icon'

const IconEnergy = ({ color, overrides, ref, size, title }) => {
  const [, theme] = useStyletron()

  title = title ?? 'Energy'
  size = size ?? 16
  color = color ?? theme.colors.primary

  return (
    <Icon viewBox='0 3 33 40' ref={ref} title={title} size={size} color={color} overrides={overrides}>
      <title>{title}</title>
      <path
        d="M43.5 -2H41.5V0H43.5V-2ZM34 26H30V30H34C34.5667 30 35.0413 29.808 35.424 29.424C35.808 29.0413 36 28.5667 36 28C36 27.4333 35.808 26.958 35.424 26.574C35.0413 26.1913 34.5667 26 34 26ZM34 34H30V38H34C34.5667 38 35.0413 37.808 35.424 37.424C35.808 37.0413 36 36.5667 36 36C36 35.4333 35.808 34.9587 35.424 34.576C35.0413 34.192 34.5667 34 34 34ZM19.176 38.826C19.9587 39.6087 20.9 40 22 40H26C26.5667 40 27.0413 39.808 27.424 39.424C27.808 39.0413 28 38.5667 28 38V26C28 25.4333 27.808 24.958 27.424 24.574C27.0413 24.1913 26.5667 24 26 24H22C20.9 24 19.9587 24.3913 19.176 25.174C18.392 25.958 18 26.9 18 28H14V36H18C18 37.1 18.392 38.042 19.176 38.826ZM2.35 31.65C3.91667 33.2167 5.8 34 8 34H12V30H8C6.9 30 5.95867 29.608 5.176 28.824C4.392 28.0413 4 27.1 4 26C4 24.9 4.392 23.958 5.176 23.174C5.95867 22.3913 6.9 22 8 22H11C12.9333 22 14.5833 21.3167 15.95 19.95C17.3167 18.5833 18 16.9333 18 15C18 13.0667 17.3167 11.4167 15.95 10.05C14.5833 8.68333 12.9333 8 11 8H4C3.43333 8 2.958 8.19133 2.574 8.574C2.19133 8.958 2 9.43333 2 10C2 10.5667 2.19133 11.042 2.574 11.426C2.958 11.8087 3.43333 12 4 12H11C11.8333 12 12.5413 12.292 13.124 12.876C13.708 13.4587 14 14.1667 14 15C14 15.8333 13.708 16.5413 13.124 17.124C12.5413 17.708 11.8333 18 11 18H8C5.8 18 3.91667 18.7833 2.35 20.35C0.783334 21.9167 0 23.8 0 26C0 28.2 0.783334 30.0833 2.35 31.65Z"
      />
    </Icon>
  )
}

IconEnergy.propTypes = {
  color: PropTypes.string,
  overrides: PropTypes.object,
  ref: PropTypes.object,
  size: PropTypes.number,
  title: PropTypes.string,
}

export default IconEnergy
